import { Component } from '@angular/core';

import { ArrayAssociative } from "./../core/array.core.data";
import { WebsocketService } from "./../services/websocket.service";

@Component({
  selector: 'neverume-uploader',
  templateUrl: './uploader.component.html',
  styleUrl: './uploader.component.scss',
  standalone: !true
})
export class UploaderComponent {
	
	files: any;
	

	constructor(private websocketService: WebsocketService) {
	}


	onFilesSelected(event: any) {
	  const files: FileList = event.target.files;

	  for (let i = 0; i < files.length; i++) {
	    const file = files[i];
	    this.processFile(file);
	  }}
	  
	   processFile(file: File) {
	      const fileType = file.type;
	      console.log('Selected file type:', fileType);

	      switch (true) {
	        case /^image\/.+/.test(fileType):
	          console.log('This is an image file.');
	          // Ваш код для обработки изображения
	          break;
	        case /^audio\/.+/.test(fileType):
	          console.log('This is an audio file.');
	          // Ваш код для обработки аудио
	          break;
	        case /^video\/.+/.test(fileType):
	          console.log('This is a video file.');
	          // Ваш код для обработки видео
	          break;
	        case /^text\/plain$/.test(fileType):
	          console.log('This is a plain text file.');
	          // Ваш код для обработки текстового файла
	          break;
	        case /^application\/pdf$/.test(fileType)://todo js api kiosk mode
	        case /^application\/msword$/.test(fileType):
	        case /^application\/vnd.openxmlformats-officedocument.wordprocessingml.document$/.test(fileType):
	        case /^application\/vnd.ms-excel$/.test(fileType):
	        case /^application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet$/.test(fileType):
	        case /^application\/vnd.ms-powerpoint$/.test(fileType):
	        case /^application\/vnd.openxmlformats-officedocument.presentationml.presentation$/.test(fileType):
	        case /^application\/zip$/.test(fileType):
	        case /^application\/x-rar-compressed$/.test(fileType):
	        case /^application\/x-7z-compressed$/.test(fileType):
	        case /^application\/x-tar$/.test(fileType):
	        case /^application\/json$/.test(fileType):
	        case /^application\/xml$/.test(fileType):
	        case /^text\/xml$/.test(fileType):
	        case /^text\/csv$/.test(fileType):
				break;
	        default:
	          console.log('Unsupported file type.');
	          // Ваш код для обработки неподдерживаемого типа файла
	      }
	    }
	  
	

	async onSubmit() {
		if (this.files.length > 0) {
		    for (const file of this.files) {
		      let fileData = await file.arrayBuffer();
		      let message: ArrayAssociative  = {
		        event: 'uploadFile',
		        route: '/upload',
		        file: fileData,
		        fileType: file.type,
		        fileName: file.name
		      };
		      // Отправляем сообщение через WebSocket или другой метод
		      this.websocketService.sendws(message);
		    }
		  }
		}
}

